const SpeechScoreLevel = {
    DOVISH: 1,
    NEUTRAL: 0,
    HAWKISH: -1,
};

export const SpeechScoreName = {
    [SpeechScoreLevel.DOVISH]: "Dovish",
    [SpeechScoreLevel.NEUTRAL]: "Neutral",
    [SpeechScoreLevel.HAWKISH]: "Hawkish",
};

export const ScoreClasses = {
    [SpeechScoreLevel.DOVISH]: "fxs_c_speech_score_dovish",
    [SpeechScoreLevel.NEUTRAL]: "fxs_c_speech_score_neutral",
    [SpeechScoreLevel.HAWKISH]: "fxs_c_speech_score_hawkish",
};